import { catchAsync } from './index.js';
import UserAPI from './user.js';

class ManufacturerAPIService {
    getByPage = catchAsync(async (page = 1, limit = 10) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/manufacturers?page=${page}&limit=${limit}`);

        const data = await res.json();
        return data;
    });

    search = catchAsync(async (keyword, page = 1, limit = 10) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/search/manufacturers?keyword=${encodeURIComponent(keyword)}&page=${page}&limit=${limit}`);

        const data = await res.json();
        return data;
    });

    getOne = catchAsync(async (uri) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/manufacturers/${uri}`);

        const data = await res.json();
        return data;
    });

    getTradenamesByUri = catchAsync(async (uri) => {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/manufacturers/${uri}/tradenames`);

        const data = await res.json();
        return data;
    });

    create = catchAsync(async (manufacturer) => {
        const token = UserAPI.getUserToken();

        if (!token) {
            return null;
        }

        const res = await fetch(`${process.env.REACT_APP_API_URL}/manufacturers/create`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(manufacturer),
        });

        const data = await res.json();
        return data;
    });

    edit = catchAsync(async (id, manufacturer) => {
        const token = UserAPI.getUserToken();

        if (!token) {
            return null;
        }

        const res = await fetch(`${process.env.REACT_APP_API_URL}/manufacturers/update/${id}`, {
            method: "PUT",
            headers: {
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify(manufacturer),
        });

        const data = await res.json();
        return data;
    });

    delete = catchAsync(async (id) => {
        const token = UserAPI.getUserToken();

        if (!token) {
            return null;
        }

        const res = await fetch(`${process.env.REACT_APP_API_URL}/manufacturers/delete/${id}`, {
            method: "DELETE",
            headers: {
                "Authorization": `Bearer ${token}`,
            },
        });

        const data = await res.json();
        return data;
    });
}

const ManufacturerAPI = new ManufacturerAPIService();
export default ManufacturerAPI; 